import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="cm-error-page">
      <div className="cm-ep-box">
        <h1 className="font-size-36 mb-2">Page not found</h1>
        <p className="mb-3">The page is deprecated, deleted, or does not exist at all</p>
        <h1 className="font-size-80 mb-4 font-weight-bold">404 —</h1>
        <Link type="button" to="/home" className="btn border text-white" style={{ color: "#fff" }}>
          &larr; Go back to the home page
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;